export default __webpack_public_path__ + "static/media/person_3.eb82c11e.png";